import { types, getParent } from 'mobx-state-tree'
import { Sideview, Orbitview } from 'src/api/misc/View/Sideview'
import { orbit, default as sides } from 'src/constants/sides'
import { IView, IDraft } from './types'
import { Padding } from 'src/api/misc/View/Padding'
import { IControlHandlerKey } from './types'
import { Project } from 'src/api/models/Project'
import { views } from 'src/constants/views'

type SideviewIdentifier = Unpacked<typeof views>

// @ts-ignore
export const Draft: IDraft = types.reference(types.late(Project), {
  get(identifier /* string */, parent: any /* Editor */) {
    const root = getParent<any>(parent, 2)
    return root.projects.get(identifier)
  },
  set(project /*  Project */) {
    return project.id
  }
})

const CurrentSide = types.reference(types.union(Sideview, Orbitview), {
  get(identifier /* string */, parent: any /* Editor */) {
    return parent.sideviews.get(identifier)
  },
  set(sideview /*  Project */) {
    return sideview.side
  }
})

export const View: IView = types
  .model('View', {
    draft: Draft,
    sideviews: types.optional(
      types.map(types.union(Sideview, Orbitview)),
      views.reduce((p, side) => ({ ...p, [side]: { side } }), {})
    ),
    currentView: types.optional(CurrentSide, orbit),
    padding: types.optional(Padding, { top: 0, right: 0, bottom: 0, left: 0 })
  })
  .actions((self) => ({
    afterCreate() {
      self.currentView.enable()
    },
    ...([
      'enable' as const,
      'disable' as const,
      'enableZoom' as const,
      'disableZoom' as const,
      'enablePan' as const,
      'disablePan' as const
    ].reduce((p, c) => ({ ...p, [c]: () => self.currentView[c]?.() }), {}) as {
      [key in IControlHandlerKey]: () => void
    }),
    switchSide(side: SideviewIdentifier) {
      const sideInstance = self.sideviews.get(side)
      self.currentView.disable()
      if (sideInstance !== undefined) {
        self.currentView = sideInstance
        self.currentView.enable()
      }
    }
  }))
